import { encodeJwt, getConfig } from "@jti/fe-common";
import { getUser } from "@jti/rest-api";
export const getUserAsJwt = () => {
    const config = getConfig();
    const { first_name, last_name, magento_token, unique_id, uuid, email, ciam_token } = getUser();
    return encodeJwt({
        unique_id,
        first_name,
        last_name,
        email,
        ciam_token,
        magento_token,
        uuid,
        tenant_code: config.CAS_X_DES_AK_TENANT_TOKEN,
        ciam_tenant_token: config.CAS_X_DES_AK_TENANT_TOKEN,
    });
};
